
  <div class="footer-wrap">
    <div class="footer-text">ver.1</div>
  </div> 
